import axios from "axios";

const baseUrl = process.env.VUE_APP_API_URL + ""; // URL для получения данных
const config = { headers: { 'Cache-Control': 'no-cache' }, withCredentials: true };

export default {
    namespaced: true,
    state: {
        orderProducts: [], // продукты из корзины, которые будут формировать новый заказ

        orders: [], // заказы пользователя
        orderItems: [], // элементы уже сформированного какого-то заказа
        orderStatuses: [], // статусы заказа
        orderNumber: null, // номер активного заказа
        paymentId: null, // идентификатор платежа в Т-Банк

        ordersKeys: {
            'Клиент (пользователь)': "customerEmail",
            'Статус': "orderStatus",
            'Дата создания': "createDate",
            'Дата завершения': "finishDate"
        }, // свойства объекта заказа, соответствие - имя переменной при отправке
    },
    mutations: {
        SET_ORDER_PRODUCTS(state, payload) {
            state.orderProducts = payload;
        },
        SET_ORDERS(state, payload) {
            state.orders = payload;
        },
        SET_ORDER_ITEMS(state, payload) {
            if (state.orders.length > 0) {
                state.orders.find(item => item["Номер"] === payload[0]["Заказ"]).orderItems = payload;
            }
        },
        SET_ORDER_STATUSES(state, payload) {
            if (state.orders.length > 0) {
                state.orders.find(item => item["Номер"] === payload[0]["Заказ"]).orderStatuses = payload;
            }
        },
        SET_ORDERS_KEYS(state, payload) {
            state.ordersKeys = payload;
        },

        SET_ORDER_NUMBER(state, payload) {
            state.orderNumber = payload;
        },
        SET_PAYMENT_ID(state, payload) {
            state.paymentId = payload;
        }
    },
    actions: {
        async fetchOrders({ commit }, params) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/orders/getOrders", {
                    params: params || {},
                    ...config
                });

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.order_id,
                            'Номер': obj.order_number,
                            'Имя клиента': obj.fullname,
                            'Email': obj.email,
                            'Статус': obj.order_status,
                            'Дата создания': obj.create_date,
                            'Дата завершения': obj.finish_date,
                            'Имя адреса': obj.address_name,
                            'Страна': obj.delivery_country,
                            'Служба доставки': obj.delivery_service,
                            'Индекс': obj.delivery_index,
                            'Регион': obj.delivery_region,
                            'Город': obj.delivery_city,
                            'Улица': obj.delivery_street,
                            'Дом': obj.delivery_house,
                            'Квартира': obj.delivery_apartment,
                        };
                    };
                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_ORDERS', transformedData);
            } catch (error) {
                console.error(error);
            }
        },
        async fetchOrderItems({ commit }, params) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/orders/getOrderItems", {
                    params: params || {},
                    ...config
                });

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.item_id,
                            'Заказ': obj.order_number,
                            'Код': obj.product_code,
                            'Название продукта': obj.product_name,
                            'Количество': obj.quantity,
                            'Обычная цена': obj.common_price,
                            'Цена по скидке': obj.sale_price,
                            'Размер': obj.size_name,
                            'Общая сумма': obj.sum_common_price,
                            'Общая сумма по скидке': obj.sum_sale_price,
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_ORDER_ITEMS', transformedData);
            } catch (error) {
                console.error(error);
            }
        },
        async fetchOrderStatuses({ commit }, params) {
            try {
                let transformedData;
                const response = await axios.get(baseUrl + "/orders/getOrderStatuses", {
                    params: params || {},
                    ...config
                });

                try {
                    const renameKeys = obj => {
                        return {
                            'ID': obj.status_id,
                            'Заказ': obj.order_number,
                            'Дата': obj.date_added,
                            'Статус': obj.order_status,
                        };
                    };

                    transformedData = response.data.map(renameKeys);
                } catch (e) {
                    transformedData = "Ошибка: не удалось получить данные";
                }

                commit('SET_ORDER_STATUSES', transformedData);
            } catch (error) {
                console.error(error);
            }
        }
    }
}